export default __webpack_public_path__ + "static/media/default_service_img.e0e36b31.png";